var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Contact Me")]),_c('p',[_vm._v("Discord: "+_vm._s(_vm.discord))]),_c('p',[_vm._v("Reddit: "),_c('a',{attrs:{"href":'https://www.reddit.com/message/compose/?to=' + _vm.reddit}},[_vm._v("click here")])])])}
var staticRenderFns = []

export { render, staticRenderFns }